<template>
  <div>
    <b-row v-if="show" class="no-gutters">
      <b-col class="d-flex justify-content-end shadow p-3">
        <template v-if="hasSelectedItems">
          <div class="float-left mr-auto">
            <b-button
              @click="metricsOverviewClicked"
            >
              Zobrazit data ({{ selectedItemsCount }})
            </b-button>
<!--            <b-button-->
<!--              class="ml-3"-->
<!--              variant="danger"-->
<!--              @click="deleteMetricsClicked"-->
<!--            >-->
<!--              Vymazat data ({{ selectedItemsCount }})-->
<!--            </b-button>-->
          </div>
          <b-button
            class="mr-3"
            @click="cancelSelection"
          >
            ({{ selectedItemsCount }}) {{ $t('clear-selected') }}
          </b-button>
          <b-button-group>
            <b-button :to="{ name: 'logging-visualization', query: { vars: varsIds } }">
              <font-awesome-icon icon="chart-line" />
              {{ $t('graph') }}
            </b-button>
            <b-button :to="{ name: 'logging-table', query: { vars: varsIds } }">
              <font-awesome-icon icon="table" />
              {{ $t('table') }}
            </b-button>
            <b-button @click="downloadCSVexport">
              <font-awesome-icon icon="file-csv" />
              CSV
            </b-button>
          </b-button-group>
        </template>
      </b-col>
    </b-row>
    <metrics-overview-modal ref="metricsOverviewModal" :vars="varsIds" :dtFromStr="dtFromStr" :dtToStr="dtToStr"  />
    <delete-metrics-modal ref="deleteMetricsModal" :vars="varsIds" />
  </div>
</template>

<script>
import axios from 'axios';
import SelectableItemsContextMenu from '@/components/context-menus/SelectableItemsContextMenu';
import { mapState } from 'vuex';
import { convertDateToISO8601 } from '@/utils/date';
import config from '@/config';
import fileDownload from 'js-file-download';
import MetricsOverviewModal from '@/components/logging/MetricsOverviewModal';
import DeleteMetricsModal from '@/components/logging/DeleteMetricsModal';

export default {
  name: 'Logging',
  components: { MetricsOverviewModal, DeleteMetricsModal },
  computed: {
    ...mapState('app', [
      'logging',
      'accessToken',
    ]),
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    varsIds() {
      return this.selectedItems.map(v => v.id);
    },
    dtFromStr() {
      return convertDateToISO8601(this.logging.selectedDtRange.from);
    },
    dtToStr() {
      return convertDateToISO8601(this.logging.selectedDtRange.to);
    },
  },
  methods: {
    cancelSelection() {
      if (this.$route.name === 'logging-default') {
        this.clearSelected();
      } else {
        this.$router.push({ name: 'logging-default' });
      }
    },
    async downloadCSVexport() {
      const url = new URL(
        config.ICOOL.API.LOG_EVENTS_PATH(this.currentSnapshot.id),
        config.ICOOL.BACKEND_HOST,
      ).href;
      try {
        const response = await axios.create({
          headers: {
            get: {
              Accept: 'text/csv', // for ordinary axios.get it appends text/csv behind the rest of accepted types
              Authorization: `Bearer ${this.accessToken}`,
            },
          },
          params: {
            vars: this.varsIds + '',
            from: this.dtFromStr,
            to: this.dtToStr,
          },
        }).request({
          url,
          method: 'get',
        });
        fileDownload(response.data, `data-${this.dtFromStr}-${this.dtToStr}.csv`);
      } catch (e) {
        console.log(e);
      }
    },
    metricsOverviewClicked() {
      this.$refs.metricsOverviewModal.show();
    },
    deleteMetricsClicked() {
      this.$refs.deleteMetricsModal.show();
    },
  },
  mixins: [
    SelectableItemsContextMenu,
  ],
};
</script>

<style scoped>

</style>
